import { render, staticRenderFns } from "./Thread.vue?vue&type=template&id=41edf40c&"
import script from "./Thread.vue?vue&type=script&lang=ts&"
export * from "./Thread.vue?vue&type=script&lang=ts&"
import style0 from "./Thread.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports